<mat-card class="p-0 mat-elevation-z0">
  <mat-card-header>
    <mat-card-title>List - Website order</mat-card-title>
  </mat-card-header>
  <mat-card-content class="pt-2 m-0">
    <button
      mat-button
      color="primary"
      class="pl-3"
      (click)="unPinAllContent(pinnedContent)"
      *ngIf="pinnedContent.length"
      disableRipple
    >
      <i class="icon icon-remove"></i>
      <span class="px-1">Clear pinned stories</span>
    </button>
    <app-processing-boundary
      [isProcessing]="isProcessing"
      [showEmptyResultMsg]="!contentDataSource.data.length"
      [emptyResultMsg]="'No content is available'"
    >
      <mat-list
        [ngClass]="{
          'content-list_view': contentDataSource.data.length,
          'pinned-table': pinnedContent.length
        }"
      >
        <div
          class="pinned-content"
          cdkDropList
          *ngIf="paginatedPinnedContent.length"
          (cdkDropListDropped)="drop($event)"
        >
          <mat-list-item
            *ngFor="let content of paginatedPinnedContent; let index = index"
            cdkDrag
            [ngClass]="{ 'pending-pinned-content': content.isPendingPin }"
            [cdkDragData]="content"
          >
            <span matListIcon>{{
              paginator.pageSize * paginator.pageIndex + index + 1
            }}</span>
            <h3 matLine>
              <strong
                ><a
                  *ngIf="
                    !(isEnabledForContentType$(content.contentType) | async)
                  "
                  [href]="'/#/content/' + content.contentId"
                  >{{ content.title }}</a
                >
                <a
                  *ngIf="isEnabledForContentType$(content.contentType) | async"
                  [routerLink]="
                    getRouteForContentType(
                      content.contentType,
                      content.contentId,
                      content.status
                    )
                  "
                  >{{ content.title }}</a
                >
              </strong>
            </h3>
            <p matLine>
              <span class="m-0">{{ content.publishedDate | formatdate }}</span>
            </p>
            <div class="flex-1"></div>
            <button
              mat-icon-button
              *ngIf="content.pinPosition"
              (click)="unPinContent([content])"
              matTooltip="Unpin"
            >
              <i class="icon icon-thumb-tack selected"></i>
            </button>
            <button
              mat-icon-button
              (click)="removeContent(content)"
              matTooltip="Remove"
            >
              <i class="icon icon-times"></i>
            </button>
          </mat-list-item>
        </div>
        <div>
          <mat-list-item
            *ngFor="let content of paginatedUnPinnedContent; let index = index"
          >
            <span matListIcon>{{
              paginator.pageSize * paginator.pageIndex +
                index +
                paginatedPinnedContent.length +
                1
            }}</span>

            <h3 matLine>
              <strong
                ><a
                  *ngIf="
                    !(isEnabledForContentType$(content.contentType) | async)
                  "
                  [href]="'/#/content/' + content.contentId"
                  >{{ content.title }}</a
                >
                <a
                  *ngIf="isEnabledForContentType$(content.contentType) | async"
                  [routerLink]="
                    getRouteForContentType(
                      content.contentType,
                      content.contentId,
                      content.status
                    )
                  "
                  >{{ content.title }}</a
                ></strong
              >
            </h3>
            <p matLine>
              <span class="m-0">{{ content.publishedDate | formatdate }}</span>
            </p>
            <div class="flex-1"></div>
            <button
              mat-icon-button
              (click)="pinAlreadyAddedContentToContentList(content)"
              matTooltip="Pin"
            >
              <i class="icon icon-thumb-tack unselected"></i>
            </button>
            <button
              mat-icon-button
              (click)="removeContent(content)"
              matTooltip="Remove"
            >
              <i class="icon icon-times"></i>
            </button>
          </mat-list-item>
        </div>
      </mat-list>
    </app-processing-boundary>
  </mat-card-content>
  <mat-card-footer class="m-0">
    <div
      class="flex items-center justify-between px-4 py-3 border-t bg-project-600 border-t-project-700"
    >
      <div>
        <!-- TODO PROTRACTOR: Leaving content-lists__page-button so protractor test dont break -->
        <mat-form-field
          [floatLabel]="'never'"
          appearance="outline"
          class="w-16 text-sm leading-[0.99rem] content-lists__page-select"
        >
          <mat-select [formControl]="pageSizeFilter">
            <mat-option *ngFor="let page of pagingOptions" [value]="page">
              {{ page }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="pl-3">per page</span>
      </div>
      <div>
        <button
          class="content-lists__page-button bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
          (click)="cmsPaginationService.previousPage(contentDataSource)"
          [disabled]="!paginator.hasPreviousPage()"
        >
          Previous
        </button>
        <button
          *ngFor="let num of cmsPaginationService.pageNumbers"
          class="content-lists__page-button bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-white"
          (click)="selectPage(contentDataSource, num)"
          [disabled]="cmsPaginationService.isActivePage(contentDataSource, num)"
          [ngClass]="{
            'content-lists__page-button--current':
              cmsPaginationService.isActivePage(contentDataSource, num)
          }"
        >
          {{ num }}
        </button>
        <button
          class="content-lists__page-button bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
          (click)="goToNextPage(contentDataSource)"
          [disabled]="allDataLoadedAndDisplayed(paginator?.hasNextPage())"
        >
          Next
        </button>
      </div>
    </div>
  </mat-card-footer>
</mat-card>

<mat-paginator
  [length]="totalContentCount"
  [pageSizeOptions]="pagingOptions"
  (page)="paginateData($event)"
  class="invisible"
>
</mat-paginator>
